import _ from 'lodash'

import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

export default function leaveTypesItems(list: string[]): string[] {
  const values = _.reduce(
    leaveTypes.models,
    (memo: Record<string, any>, item: LeaveType) => {
      if (item.isCustom) {
        memo[item.attributes.name] = item.attributes.name
      } else {
        memo[item.attributes.identifier] = item.attributes.name
      }

      return memo
    },
    {}
  )

  return list.map((value: string) => {
    return values[value]
  })
}
